import { render, staticRenderFns } from "./Klachten.vue?vue&type=template&id=8b17fce8&scoped=true"
import script from "./Klachten.vue?vue&type=script&lang=ts"
export * from "./Klachten.vue?vue&type=script&lang=ts"
import style0 from "./Klachten.vue?vue&type=style&index=0&id=8b17fce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b17fce8",
  null
  
)

export default component.exports